module.exports = __webpack_public_path__ + "img/modal-bg.2e3a35e5.png";